export default function Product (props) {
  props = props || {}
  const self = {
    imageSrc: props.image && props.image.src,
    sku: props.variants && props.variants[0].sku || props.sku,
    isFromCanvas: props.isFromCanvas
  }

  return Object.assign({}, props, self)
}
